<div style="width: 400px; height: 520px;">
    <sc-flex vertical stretchContent fitHeight>
        <sc-dialog-title>
          <sc-dictionary-label dictionaryKey="tmc-yard.select-loading-zone.title"></sc-dictionary-label>
        </sc-dialog-title>

        <sc-flex-fitting-content vertical>
            <sc-scroll-pane>
                <sc-padding>
                    <ng-container *ngIf="station != null">
                        <ng-container
                            *ngFor="let loadingZone of station.stationUsage.availableLoadingZones; let i = index">
                            <sc-content-spacer vertical *ngIf="i > 0"></sc-content-spacer>
                            <sc-bordered [highlight]="selected === loadingZone" (click)="setSelected(loadingZone)"
                                class="pointer">
                                <div [ngClass]="{'selected-item' : selected === loadingZone}">
                                    <sc-padding>
                                        {{loadingZone.name}}
                                    </sc-padding>
                                </div>
                            </sc-bordered>
                        </ng-container>
                    </ng-container>
                </sc-padding>
            </sc-scroll-pane>
        </sc-flex-fitting-content>

        <sc-padding>
            <sc-flex>
                <sc-content-spacer grow></sc-content-spacer>
                <button mat-stroked-button (click)="close()">
                  <sc-dictionary-label dictionaryKey="tmc-yard.common.action.cancel"></sc-dictionary-label>
                </button>
                <sc-content-spacer></sc-content-spacer>
                <button mat-flat-button (click)="confirm()" [disabled]="selected == null">
                  <sc-dictionary-label dictionaryKey="tmc-yard.action.confirm"></sc-dictionary-label>
                </button>
            </sc-flex>
        </sc-padding>
    </sc-flex>
</div>
